import React, { Component, useCallback, useState } from 'react';

import * as Atoms from '../../Atoms';
import * as Molecules from '../../Molecules';
import * as Organisms from '../../Organisms';
import * as Components from 'components';

import * as T from './interfaces';
import {
  Container,
  ContainerCarousel,
  ContainerButton,
  Highlights,
  ContainerInput,
  ContainerFilterCardapio,
  ShadowGradient,
  ContainerHeading,
  TitleScrolledDesktop,
} from './styles';
import ImageHardcoded1 from '../../Pages/MenuRestaurant/Assets/1.svg';
import ImageHardcoded2 from '../../Pages/MenuRestaurant/Assets/2.png';
import { font } from 'styles';

export const HeaderMenu: React.FC<T.IHeaderMenu> = ({
  id,
  numberOfPagesCarousel,
  handleUpdateCategories,
  onToogleCategories,
  openCategories,
  filters,
  hideBanner,
  hideBackButton,
  backgroundColorBackButton,
  hideSearch,
  handleClickSearchButtonMobile,
  isSearchButtonClick,
  onPressCupom,
  onPressAnyCategoryFilter,
  storeSelected,
  ...rest
}) => {
  const items = [
    {
      labels: 'StatusList',
      title: 'Gigante',
      img: ImageHardcoded1,
      isDisabled: false,
      price: 28.9,
      unavailable: false,
    },
    {
      labels: 'StatusList',
      title: 'Grande',
      img: ImageHardcoded2,
      isDisabled: false,
      price: 28.9,
      unavailable: false,
    },
  ];

  const FSlide = () => {
    return (
      <div style={{ width: '100%' }}>
        <img
          src="https://s3.amazonaws.com/media.appbk.burgerking.com.br/v3/a27f951785713eef17e0a70b62bf53a63e5e3ceded1d2a77bf64601450447364.png"
          alt="teste"
        />
      </div>
    );
  };

  return (
    <Container {...rest} data-testid={`HeaderMenu@${id}`}>
      <Molecules.BackButtonHeader
        isTitle
        id="menuRestaurant"
        hideDesktop={hideBackButton}
        isBackgroundColor={backgroundColorBackButton}
        showIconSearch={hideSearch}
        hideBanner={hideBanner}
        handleClickSearchButtonMobile={handleClickSearchButtonMobile}
        storeSelected={storeSelected}
      />
      <ContainerCarousel hideBanner={hideBanner}>
        <Atoms.Carousel
          autoPlay={numberOfPagesCarousel > 1}
          handleHomeButtons
          Components={[FSlide(), FSlide()]}
          showCarrouselButtons={numberOfPagesCarousel > 1}
          sizeCarousel="S"
          carouselMobilePositionTop={!storeSelected?.id}
        />
      </ContainerCarousel>
      <ContainerButton hideBanner={hideBanner}>
        <Atoms.Button
          variant="menu"
          id="SeeCupons"
          title="Ver todos os cupons"
          font="bold"
          onClick={onPressCupom}
        >
          Ver todos os cupons
        </Atoms.Button>
      </ContainerButton>
      <ContainerHeading hideBanner={hideBanner} hideSearch={hideSearch}>
        <span>Cardápio</span>
        <Atoms.Heading bold level={1} fontSizeTitle id="Cardapio">
          Cardápio
        </Atoms.Heading>
      </ContainerHeading>
      <TitleScrolledDesktop hideBanner={hideBanner} hideSearch={hideSearch}>
        <Atoms.Heading bold level={1} fontSizeTitle id="Cardapio">
          Cardápio
        </Atoms.Heading>
      </TitleScrolledDesktop>
      <Highlights>
        <Components.ScrollDrag>
          <Molecules.Filter
            filtersItem={filters}
            id="MenuFilter"
            onToogleCategories={option => onToogleCategories(option)}
            openCategories={openCategories}
            onChangeFilter={newCategories =>
              handleUpdateCategories(newCategories)
            }
          />
        </Components.ScrollDrag>
      </Highlights>

      {!hideSearch && (
        <ContainerInput>
          <Atoms.Input
            placeholder="Buscar"
            name="Buscar"
            id="search"
            label="Buscar"
            type="search"
          />
        </ContainerInput>
      )}
      <ContainerFilterCardapio
        hideSearch={hideSearch}
        isSearchButtonClick={isSearchButtonClick}
        positionFilterMobileTop={!storeSelected?.id}
      >
        <Molecules.FilterCardapio
          id="Filtros"
          hideFilterCardapio={hideSearch}
          inputSelectedMobile={isSearchButtonClick}
          onPressAnyCategoryFilter={onPressAnyCategoryFilter}
        />
      </ContainerFilterCardapio>
    </Container>
  );
};
